<ng-container *ngIf="costGroupState$ | async as state">

    <div class="contribution-margin-level-container mat-elevation-z8">
        <div class="table-header">
            <mat-form-field subscriptSizing="dynamic">
                <input matInput #filter (keyup)="applyFilter($event.target.value)" placeholder="Filter">
                <button mat-icon-button matSuffix aria-label="clear" *ngIf="filter.value" (click)="filter.value=''; applyFilter('');">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>

            <button mat-mini-fab
                    color="primary"
                    matTooltip="{{ 'app.page.contribution-margin-level.actions.add.label' | translate }}"
                    (click)="onCreate()">
                <mat-icon>add</mat-icon>
            </button>
        </div>
        <mat-progress-bar color="accent" [style.visibility]="state.isLoading ? 'visible' : 'hidden'" mode="indeterminate"></mat-progress-bar>
        <div class="table-container">
            <table mat-table [dataSource]="dataSource" matSort matSortActive="order" matSortDirection="asc">

                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "app.model.contribution-margin-level.name.label" | translate }}</th>
                    <td mat-cell *matCellDef="let element">
                        {{element.name}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="order">
                    <th mat-header-cell *matHeaderCellDef arrowPosition="before" mat-sort-header>{{ "app.model.contribution-margin-level.order.label" | translate }}</th>
                    <td mat-cell *matCellDef="let element">
                        {{element.order}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="edit-button">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let element" class="actions-column">
                        <button mat-icon-button
                                color="primary"
                                matTooltip="{{ 'app.page.contribution-margin-level.actions.edit.label' | translate }}"
                                (click)="onEdit(element)">
                            <mat-icon>edit</mat-icon>
                        </button>
                        <button mat-icon-button
                                color="warn"
                                matTooltip="{{ 'app.page.contribution-margin-level.actions.delete.label' | translate }}"
                                (click)="onDeleteContributionMarginLevel(element)">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="state.columns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: state.columns;"></tr>
            </table>
        </div>
    </div>
</ng-container>
